export default __webpack_public_path__ + "static/media/settlement.105cd57a.png";